import React, { useEffect } from 'react';
import { types } from './../../../utilities'
import FeatherIcon from 'feather-icons-react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { UserInitials } from 'components/utilities';


import {
  mLogoMini,
  bloghouseLogoSmall,
  businessLogoSimple
} from '../../../assets/images';


import { 
  setActivelink, 
  fixedHeaderSpace,
  setupWindowResizeListener, 
  coverimg,
  initSidebar,
  
} from '../../utilities/domFunctions';

import { useOpenConfig } from 'utilities/variables/openConfigContext'; 


interface MobileHeaderProps {
    userAttributes: types.IAccountUserAttributes | null;
    handleSignOut: (event: React.MouseEvent) => Promise<void>;
  }

export const MobileHeader: React.FC<MobileHeaderProps> = ({ userAttributes, handleSignOut }) => {


  useEffect(() => {
    initSidebar();
    setActivelink();
    fixedHeaderSpace();
    setupWindowResizeListener();
    coverimg();
  }, []);

  const { config } = useOpenConfig();

  const goHome = async (event: React.MouseEvent) => {
    event.preventDefault();
    window.location.href = '/';
  }


  return (
    <>
      <header className="adminuiux-header">
        {/* Fixed navbar */}
        <nav className="navbar navbar-expand-lg fixed-top">
          <div className="container-fluid">

            {/* main sidebar toggle */}
            <button className="btn btn-link btn-square sidebar-toggler" type="button" onClick={goHome}>
              {/*<FeatherIcon className="sidebar-svg" icon="menu" />*/}
              {config ? (
                config.BRANDING === 'GENERIC' ? (
                  <img className="sidebar-svg k-h-1-7em"src={businessLogoSimple} alt="G"/>
                ) : config.BRANDING === 'KURO' ? (
                  <img className="sidebar-svg k-h-1-7em"src={mLogoMini} alt="K"/>
                ) : (
                  <img className="sidebar-svg k-h-1-7em"src={bloghouseLogoSmall} alt=""/>
                )
              ) : null
              }
            </button>

            {/* right icons button */}
            <div className="ms-auto">

              {/* notification dropdown */}
              <div className="dropdown d-inline-block">
                <button className="btn btn-link btn-square btn-icon btn-link-header dropdown-toggle no-caret k-bs-btn-col-black" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <FeatherIcon icon="bell" color="black"/>
                </button>
              </div>

              {/* profile dropdown */}
              {userAttributes &&
                <div className="dropdown d-inline-block">
                  <a href="#" className="dropdown-toggle btn btn-link btn-square btn-link-header style-none no-caret px-0" id="userprofileddMainHeader" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                    <div className="row gx-0 d-inline-flex">
                      <div className="col-auto align-self-center">
                        <figure className="avatar coverimg align-middle">
                          <UserInitials input={userAttributes && userAttributes.displayName} backgroundColor="white" width="28px" height="28px" fontSize="12px" color="black" border="1px solid black" marginRight='0px' />
                        </figure>
                      </div>
                    </div>
                  </a>
                  <div className="dropdown-menu dropdown-menu-end width-300 pt-0 px-0" aria-labelledby="userprofileddMainHeader">
                    <div className="bg-theme-1-space rounded py-2 mb-3 dropdown-dontclose">
                      <div className="row gx-0">
                        <div className="col-auto px-3">
                          <div className="avatar coverimg align-middle">
                            <UserInitials input={userAttributes && userAttributes.displayName} backgroundColor="white" width="40px" height="40px" fontSize="20px" color="black" border="1px solid black" marginRight='0px' />
                          </div>
                        </div>
                        <div className="col align-self-center ">
                          <p className="mb-1"><span>{userAttributes.displayName}</span></p>
                          <p className='k-mt-min-10'><small className="opacity-50">{userAttributes.identifier}</small>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="px-2">
                      {/*<div className='mb-1'>
                        <a className="dropdown-item" href="investment-myprofile.html"> 
                          <FeatherIcon className="avatar avatar-18 me-1" icon="user" />
                            Account Settings
                        </a>
                      </div>
                      */}
                      <div>
                        <a className="dropdown-item theme-red" onClick={handleSignOut}> 
                          <FeatherIcon className="avatar avatar-18 me-1" icon="power" />
                            Logout
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </nav>
      </header>
    </>
  )

}